module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"8\" height=\"12\" viewBox=\"0 0 8 12\"><path fill-rule=\"evenodd\" fill=\"#FFF\" d=\"M0 0h8v2H0V0zm0 10h8v2H0v-2zm0-5h8v2H0V5z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/icons/dropdown-bars.svg
// module id = ./node_modules/raw-loader/index.js!./src/icons/dropdown-bars.svg
// module chunks = 168707334958949